<template>
  <div>
    <div class="total_infor">
      机针总余额：{{counts1}}
    </div>
    <div class="list-con">
      <el-table
        ref="filterTable"
        :data="tabelData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          :prop="item.key"
          :label="item.label"
          v-for="item in dataSource"
          :key="item.key"
        >
          <template slot-scope="scope">
            <div class="text" v-if="!slotmap.includes(item.key)">
              {{ scope.row[item.key] }}
            </div>
            <div v-else-if="item.key == 'menu'" class="tab-menu">
              <div class="edit" @click="edit(scope.row)">新增记录</div>
              <div class="line"></div>
              <div class="edit" @click="list(scope.row)">记录查看</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
      <div class="pages" style="display:block;height:auto;">
    <el-pagination
      background
      layout="prev, pager, next"
      :total="numdata"
      style="margin-top: 30px; float: right; margin-right: 60px"
      :current-page="current_page" 
      :page-size="page_size"
      @current-change="handleCurrentChange"
      @prev-click="handleCurrentChange_prev"
      @next-click="handleCurrentChange_next"
    >
    </el-pagination>
    </div>   
    <el-dialog
      :visible="editvisible"
      v-if="editvisible"
      :modal-append-to-body="true"
      custom-class="edit-dialog"
      @close="dialogclose"
      :destroy-on-close="true"
      width="720px"
    >
      <div slot="title">新增数量</div>
      <div class="edit-content">
        <div class="edit-item">
          <div class="text">新增数量</div>
          <el-input
            class="edit-input"
            v-model="formData.quantity"
            placeholder=""
          ></el-input>
        </div>
      </div>
      <div slot="footer">
        <div class="button-group">
          <el-button type="info" size="small" @click="dialogclose"
            >取消</el-button
          >
          <el-button @click="adds" type="primary" size="small">确定</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible="listvisible"
      v-if="listvisible"
      :modal-append-to-body="true"
      custom-class="edit-dialog"
      @close="dialogclose2"
      :destroy-on-close="true"
      width="720px"
    >
      <div slot="title">记录查看</div>
      <div class="list_content">
        <div class="tt">
          <div class="single">放针时间</div>
          <div class="single">放针数量</div>
        </div>
        <div class="tt2" v-for="(item,index) in boxRecordList">
          <div class="single">{{formatDate(item.create_time)}}</div>
          <div class="single">{{item.quantity}}</div>
        </div>        
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="exportdialog"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :show-close="false"
      width="400px"
      class="loading-dialog"
    >
      <div class="loading-wrap">
        <i class="el-icon-loading loading-icon"></i>
        <div class="loading-title">Execl数据导出中</div>
        <div class="loading-text">正在从服务器获取数据，请耐心等待...</div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { getBoxRecordLists,addBoxRecords,needleBoxConfig } from "@/api/index";
import * as XLSX from 'xlsx'

export default {
  props: {
    searchval: {
      type: String,
      default() {
        return "";
      },
    },  
  },  
  watch: {
    searchval(newValue, oldValue) {   
        if(newValue!=oldValue){
            this.current_page=1;
            this.getData();
        }
    }, 
  },    
  mounted() {
    this.getData();
  },
  data() {
    return {
      dataSource: [
        { label: "设备编号", key: "sn" },
        { label: "机针分类", key: "classify_name" },
        { label: "针名", key: "channel_name" },
        { label: "通道号", key: "channel_id" },
        { label: "可放针数量", key: "total" },
        { label: "当前余额", key: "stock" },
        { label: "备注", key: "remark" },
        { label: "操作", key: "menu" },
      ],
      tabelData: [],
      editvisible: false,
      listvisible:false,
      selectrow: {},
      dialogmap: [
        //{ name: "针类型", value: "channel_id" },
        { name: "放针数量", value: "num" },
      ],
      slotmap: ["menu"],
      formData:{
        box_id:0,
        quantity:"",
      },
      boxRecordList:[],//针盒添加记录
      numdata: 0,
      current_page: 1,
      page_size:10,
      counts1: 0,
      exportLoading: false,
      exportdialog: false
    };
  },
  methods: {
    handleCurrentChange_next() {
      this.current_page += 1;
    },
    handleCurrentChange_prev() {
      this.current_page -= 1;
    },
    handleCurrentChange(val) {
      this.current_page=val;
      this.getData();
    },        
    getData(){
      let params={};
      if(this.searchval){
          params = {
            limit: this.page_size,
            page: this.current_page,  
            "search[0][field]": "device.sn",
            "search[0][val]": this.searchval,
            "search[0][operator]": "LIKE",                        
          };  
      }else{
          params = {
            limit: this.page_size,
            page: this.current_page,               
          };  
      }       
      needleBoxConfig(params)
        .then((res) => {
          if (res.code == 1) {
            this.tabelData = res.data.list;
            this.numdata = res.data.total
            this.counts1 = res.data.total_stock
            for(var i=0;i<this.tabelData.length;i++){
              this.tabelData[i].sn=this.tabelData[i].device.device_name;
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    formatDate(value) {// 时间戳转换日期格式方法
        if (value == null) {
            return '';
        } else {
            value=value*1000
            let date = new Date(value);
            let y = date.getFullYear();// 年
            let MM = date.getMonth() + 1;// 月
            MM = MM < 10 ? ('0' + MM) : MM;
            let d = date.getDate();// 日
            d = d < 10 ? ('0' + d) : d;
            let h = date.getHours();// 时
            h = h < 10 ? ('0' + h) : h;
            let m = date.getMinutes();// 分
            m = m < 10 ? ('0' + m) : m;
            let s = date.getSeconds();// 秒
            s = s < 10 ? ('0' + s) : s;
            return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
        }
    },     
    adds(){
      if(!this.formData.quantity){
        this.$message.warning("新增数量不能为空!");
        return;
      }    
      addBoxRecords(this.formData)
        .then((res) => {
          if (res.code == 1) {
            this.editvisible = false;
            this.$message.success("添加成功!");
            this.getData();
          } else {
            this.$message.error("添加失败");
          }

          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        }); 
    },
    async exportExcel() {
      this.exportLoading = true
      this.exportdialog = true
      try {
        const boxes = await this.fetchAllBoxData()
        const allRows = []

        for (let i = 0; i < boxes.length; i++) {
          const box = boxes[i]
          let records = []
          try {
            records = await this.fetchBoxRecords(box.id)
          } catch (e) {
            records = []
          }

          if (records.length === 0) {
            allRows.push({
              '设备编号': box.device ? box.device.device_name : '',
              '机针分类': box.classify_name || '',
              '针名': box.channel_name || '',
              '通道号': box.channel_id || '',
              '可放针数量': box.total || '',
              '当前余额': box.stock || '',
              '放针时间': '',
              '放针数量': ''
            })
          } else {
            for (const record of records) {
              allRows.push({
                '设备编号': box.device ? box.device.device_name : '',
                '机针分类': box.classify_name || '',
                '针名': box.channel_name || '',
                '通道号': box.channel_id || '',
                '可放针数量': box.total || '',
                '当前余额': box.stock || '',
                '放针时间': this.formatDate(record.create_time),
                '放针数量': record.quantity
              })
            }
          }
        }

        const ws = XLSX.utils.json_to_sheet(allRows)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, '针盒数量配置')
        XLSX.writeFile(wb, '针盒数量配置.xlsx')
      } catch (error) {
        console.log(error)
        this.$message.error('导出失败')
      }
      this.exportdialog = false
      this.exportLoading = false
    },
    fetchAllBoxData() {
      return new Promise((resolve, reject) => {
        this._fetchBoxPage(resolve, reject, 1, [])
      })
    },
    _fetchBoxPage(resolve, reject, page, allData) {
      let params = { limit: 100, page: page }
      if (this.searchval) {
        params["search[0][field]"] = "device.sn"
        params["search[0][val]"] = this.searchval
        params["search[0][operator]"] = "LIKE"
      }
      needleBoxConfig(params)
        .then((res) => {
          if (res.code == 1) {
            const newData = allData.concat(res.data.list)
            if (res.data.list.length < 100) {
              resolve(newData)
            } else {
              this._fetchBoxPage(resolve, reject, page + 1, newData)
            }
          } else {
            reject(new Error(res.msg))
          }
        })
        .catch((error) => {
          reject(error)
        })
    },
    fetchBoxRecords(boxId) {
      return new Promise((resolve) => {
        getBoxRecordLists({ limit: 1000, page: 1, box_id: boxId })
          .then((res) => {
            if (res.code == 1) {
              resolve(res.data.list)
            } else {
              resolve([])
            }
          })
          .catch(() => {
            resolve([])
          })
      })
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    edit(item) {
      this.selectrow = item;
      this.formData.box_id=item.id;
      this.formData.quantity="";
      this.editvisible = true;
    },
    list(item){
      this.listvisible=true;
      this.getBoxList(item.id);
    },
    getBoxList(id){
      let params={
        limit:1000,
        page:1,
        box_id:id,
      };
      getBoxRecordLists(params)
        .then((res) => {
          if (res.code == 1) {
            this.boxRecordList=res.data.list;
          } else {
            this.$message.error("获取失败");
          }
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        }); 
    },
    itemdel() {},
    dialogclose() {
      this.editvisible = false;
    },
    dialogclose2() {
      this.listvisible = false;
    },    
  },
};
</script>

<style lang="scss" scoped>
.total_infor{display:block;width:98%;margin:0px auto;color:#4f77f3;font-size:15px;}
.tab-menu {
  display: flex;
  align-items: center;
  font-family: Source Han Sans CN;
  font-weight: 500;
  font-size: 14px;
  color: #507af9;
  column-gap: 13px;
  .line {
    width: 1px;
    height: 12px;
    background: #e6e6e6;
  }
  .edit {
    cursor: pointer;
  }
  .delbtn {
    cursor: pointer;
    color: #f95050;
  }
}
.list_content{overflow:hidden;width:80%;margin:0px auto;padding-bottom:30px;}
.list_content .tt{width:100%;line-height:45px;font-size:14px;color:#303030;font-weight:550;overflow:hidden;}
.list_content .tt .single{width:50%;float:left;border-bottom:solid 1px #eee;}
.list_content .tt{width:100%;line-height:45px;font-size:14px;color:#303030;font-weight:550;text-align:center;}
.list_content .tt2{width:100%;line-height:45px;font-size:14px;color:#646464;overflow:hidden;}
.list_content .tt2 .single{width:50%;float:left;text-align:center;border-bottom:solid 1px #eee;}
</style>
<style lang="scss">
.loading-dialog .el-dialog__body {
  padding: 50px 20px;
}
.loading-wrap {
  text-align: center;
  .loading-icon {
    font-size: 60px;
    color: #409eff;
    animation: rotating 1.5s linear infinite;
  }
  .loading-title {
    margin-top: 20px;
    font-size: 20px;
    font-weight: 600;
    color: #303133;
  }
  .loading-text {
    margin-top: 10px;
    font-size: 14px;
    color: #909399;
  }
}
@keyframes rotating {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>